import {Component, Inject, OnInit, Renderer2} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../services/authentication/authentication.service';
import {cities, djangourl} from 'src/assets/urls';
import {animate, style, transition, trigger} from '@angular/animations';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-buy',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'rotateY(80deg)', opacity: 0}),
          animate('500ms', style({transform: 'rotateY(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'rotateY(0)', opacity: 1}),
          animate('500ms', style({transform: 'rotateY(-70deg)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class RequestComponent implements OnInit {

  userUrl = djangourl + 'api/user/';
  productUrl = djangourl + 'api/products/';
  orderUrl = djangourl + 'api/orders/';
  paymentUrl = djangourl + 'zarinpal/request/';
  codeUrl = djangourl + 'api/offcodes/';
  djangourl = djangourl.substring(0, djangourl.length - 1);
  next = false;
  userForm: FormGroup;
  submitted = false;
  error = '';
  product: any;
  loading = false;
  code: any;
  validCode = '';
  private codeDiscount = 0;
  success: any;
  loggedin: boolean;
  states = cities;
  parts = 1;
  selectedState = {
    name: '',
    Cities: [{name: ''}]
  };
  two_part = false;
  canPartPay = true;
  // cantTwoPartProducts = [
  //   'ecb45cac-d48b-426c-aa0b-158f44727353',
  // ];
  finalPrice: any;

  constructor(private http: HttpClient,
              private authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private router: Router,
              private route: ActivatedRoute,
              private renderer2: Renderer2,
              @Inject(DOCUMENT) private _document) {
  }

  ngOnInit() {


    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      this.loggedin = true;
    } else {
      this.loggedin = false;
      return;
    }
    this.userForm = this.formBuilder.group({
      username: [currentUser.username],
      first_name: [currentUser.first_name, Validators.required],
      last_name: [currentUser.last_name, Validators.required],
      address: [currentUser.address, Validators.required],
      postal_code: [currentUser.postal_code, Validators.required],
      token: [currentUser.token],
      role: [currentUser.role],
      id: [currentUser.id],
      state: [currentUser.state],
      city: [currentUser.city],
    });
    this.selectState();
    this.f.city.setValue(currentUser.city);
    this.route
      .params
      .subscribe(v => {
        this.http.get(this.productUrl + v.id).subscribe(data => {
          this.product = data;
          this.change_part(1);
          if (this.product.parts <= 1) {
            this.canPartPay = false;
          }

        });
      });

  }

  get f() {
    return this.userForm.controls;
  }


  onSubmit() {
    this.submitted = true;
    this.error = '';
    if (this.userForm.invalid) {
      return;
    }
    this.loading = true;
    this.http.post(this.userUrl, this.userForm.value, {headers: {}}).subscribe(data => {
      this.loading = false;
      if (data['error']) {
        this.error = data['message'];
        return;
      }
      this.authenticationService.currentUserSubject = this.userForm.value;
      this.next = true;

    }, error => {
      this.error = error;
      this.loading = false;
    });
  }

  sendCode() {
    this.validCode = '';
    this.codeDiscount = 0;
    this.success = '';

    this.error = '';
    this.loading = true;
    this.http.get(this.codeUrl + this.code).subscribe(data => {
      this.loading = false;
      if (data['error']) {
        this.error = 'کد تخفیف پیدا نشد';
        return;
      }
      if (data['used']) {
        this.error = 'کد تخفیف استفاده شده است';
        return;
      }
      if (data['pending']) {
        this.error = 'کد تخفیف در حال استفاده است... ' +
          '\n' +
          'در صورتی که قبلا از این کد تخفیف استفاده کرده اید و عملیات پرداخت ناموفق بوده، لطفا به پروفایل کاربری خود مراجعه کنید و از قسمت سفارش های من عملیات پرداخت را انجام دهید';
        return;
      }

      if (new Date(data['expire']) < new Date()) {
        this.error = 'کد تخفیف منقضی شده است';
        return;
      }


      this.success = 'کد تخفیف ' + data['amount'] + ' درصدی اعمال شد';
      this.validCode = this.code;
      this.codeDiscount = data['amount'];
      this.change_part(this.parts);
    }, error => {
      this.error = 'کد تخفیف پیدا نشد';
      this.loading = false;
    });

  }

  buy() {


    const order = {
      buyer: this.authenticationService.currentUserValue.id,
      product: this.product.id,
      code: this.validCode,
      parts: this.parts
    };
    //console.log(order);

    this.http.post(this.orderUrl, order, {headers: {}}).subscribe(data => {
      this.loading = false;
      if (data['error']) {
        this.error = data['message'];
        return;
      }
      // console.log(data);
      window.location.href = this.paymentUrl + data['id'];
    }, error => {
      this.error = error;
      this.loading = false;
    });
  }

  numberWithCommas(x) {
    return (Math.floor(x)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  numberWithCommasCeil(x) {
    return (Math.ceil(x)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }


  toint(x) {
    return Math.round(x);
  }

  selectState() {
    const state = this.f.state.value;
    let c;
    this.states.forEach(function (value) {
      if (value.name === state) {
        c = value;
      }
    });
    this.f.city.setValue('');
    this.selectedState = c;

  }

  change_part(event) {
    this.finalPrice = this.numberWithCommas(
      (this.product.price - ((this.product.discount + this.codeDiscount) / 100 * this.product.price)) / parseInt(event, 10));
  }
}
